module.exports = __webpack_public_path__ + "static/drawing-modal-8f1819a3cb01ec04d83d4b40e9d71de9.png";